const stringHelpers = require('../../../common/components/stringhelpers');

function getTitle(searchCount, type, count) {
    const result = {};
    if (searchCount && count !== undefined && !searchCount.loadingCount) {
        result.loading = false;
        result.title = `All ${type} (${count})`;
    } else {
        result.loading = true;
        result.title = `All ${type} `;
    }

    return result;
}

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.search', {
            url: '/search?searchTerm?{multisearchItems}&{name}&{productId:int}&{recipeId:int}&{cardId:int}&{pageNumber:int}&{filters}&{sortby}',
            views: {
                'left-panel@': {
                    template: '<wow-filters-mobile></wow-filters-mobile>'
                },
                'center-panel@': {
                    template: '<wow-search-page></wow-search-page>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                }
            },
            data: {
                analytics: 'bws:web:search:search results',
                pageMetadata: [
                    '$state', function ($state) {
                        const searchTerm = stringHelpers.toTitleCase($state.params.searchTerm.replace(new RegExp('-', 'g'), ' '));
                        return $state.params.searchTerm
                            ? {
                                title: searchTerm + ' - BWS Online',
                                metaDescription: searchTerm + ' - BWS Online',
                                metaRobot: 'noindex, nofollow'
                            }
                            : {
                                title: 'Search - BWS Online',
                                metaDescription: 'Search - BWS Online',
                                metaRobot: 'noindex, nofollow'
                            };
                    }
                ]
            }
        })
        .state('shop.search.products', {
            url: '/products',
            onEnter: [
                'PerformanceMeasurerService', function (performance) {
                    performance.startMeasure('search.products init');
                }
            ],
            views: {
                'center-panel@': {
                    template: require('../../components/search/search-products-center-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'SearchService', 'BreakpointsService', 'SettingsService', '$scope',
                        function (searchService, breakpointsService, settingsService, $scope) {
                            $scope.showHeader = false;
                            $scope.breakpointsService = breakpointsService;

                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });

                            $scope.redirectTo = 'shop.search';
                            let header = getTitle(searchService.SearchCount, 'Products', searchService.SearchCount.ProductCount);
                            $scope.title = header.title;
                            $scope.loading = header.loading;

                            $scope.showHeader = true;

                            $scope.$watch(function () { return searchService.SearchCount; },
                                function (searchCount) {
                                    header = getTitle(searchCount, 'Products', searchCount.ProductCount);
                                    $scope.title = header.title;
                                    $scope.loading = header.loading;
                                });

                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled" ng-show="showHeader"></oly-sticky-header-with-text>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true,
                analytics: `bws:web:products`
            }
        })
        .state('shop.search.products.category', {
            url: '/:category/:aisle',
            onEnter: [
                'PerformanceMeasurerService', function (performance) {
                    performance.startMeasure('search.products category init');
                }
            ],
            views: {
                'center-panel@': {
                    template: require('../../components/search/search-products-category-center-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'SearchService', 'BreakpointsService', 'SettingsService', 'CategoriesService', '$scope', '$stateParams',
                        function (searchService, breakpointsService, settingsService, categoriesService, $scope, $stateParams) {
                            this.$onInit = function() {
                                $scope.breakpointsService = breakpointsService;

                                settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                    $scope.smallFormatCentrePanelSlideEnabled = setting;
                                });

                                $scope.redirectTo = 'shop.search';

                                $scope.category = categoriesService.getCategoryByName(searchService.categories, $stateParams.aisle, $stateParams.category);
                                $scope.selectedCategory = $scope.category.childCategory;
                                $scope.title = $scope.selectedCategory.Name;
                                $scope.retinaDisplayimage = `/Content/Categories/${$scope.selectedCategory.ImageFile}`;
                                $scope.image = `/Content/Categories/${$scope.selectedCategory.ImageFile}`;
                            };
                        }
                    ],
                    template: '<oly-sticky-header-with-image retina-image="retinaDisplayimage" image="image" title="title" redirect-to="redirectTo" ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-image>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true,
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:products-category:${$state.params.category}`;
                    }
                ]
            }
        })
        .state('shop.search.specials', {
            url: '/specials',
            onEnter: [
                'PerformanceMeasurerService', function (performance) {
                    performance.startMeasure('search.specials init');
                }
            ],
            views: {
                'center-panel@': {
                    template: require('../../components/search/search-specials-center-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'SearchService', 'BreakpointsService', 'SettingsService', '$scope',
                        function (searchService, breakpointsService, settingsService, $scope) {
                            $scope.showHeader = false;
                            $scope.breakpointsService = breakpointsService;

                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });

                            $scope.redirectTo = 'shop.search';
                            let header = getTitle(searchService.SearchCount, 'Specials', searchService.SearchCount.SpecialProductCount);
                            $scope.title = header.title;
                            $scope.loading = header.loading;

                            $scope.showHeader = true;

                            $scope.$watch(function () { return searchService.SearchCount; },
                                function (searchCount) {
                                    header = getTitle(searchCount, 'Specials', searchCount.SpecialProductCount);
                                    $scope.title = header.title;
                                    $scope.loading = header.loading;
                                });
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled" ng-show="showHeader"></oly-sticky-header-with-text>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true,
                analytics: `bws:web:specials`
            }
        })
        .state('shop.search.specials.category', {
            url: '/:category/:aisle',
            onEnter: [
                'PerformanceMeasurerService', function (performance) {
                    performance.startMeasure('search.specials category init');
                }
            ],
            views: {
                'center-panel@': {
                    template: require('../../components/search/search-specials-category-center-template.html').trim()
                },
                'sticky-header@': {
                    controller: [
                        'SearchService', 'BreakpointsService', 'SettingsService', 'CategoriesService', '$scope', '$stateParams',
                        function (searchService, breakpointsService, settingsService, categoriesService, $scope, $stateParams) {
                            this.$onInit = function() {
                                $scope.breakpointsService = breakpointsService;

                                settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                    $scope.smallFormatCentrePanelSlideEnabled = setting;
                                });

                                $scope.redirectTo = 'shop.search';

                                $scope.category = categoriesService.getCategoryByName(searchService.categories, $stateParams.aisle, $stateParams.category);
                                $scope.selectedCategory = $scope.category.aisle;
                                $scope.title = $scope.selectedCategory.Name;
                                $scope.retinaDisplayimage = `/Content/Categories/${$scope.selectedCategory.ImageFile}`;
                                $scope.image = `/Content/Categories/${$scope.selectedCategory.ImageFile}`;
                            };
                        }
                    ],
                    template: '<oly-sticky-header-with-image retina-image="retinaDisplayimage" image="image" title="title" redirect-to="redirectTo" ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled"></oly-sticky-header-with-image>'
                }
            },
            data: {
                showBothPanelsInSmallFormat: true,
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:specials-category:${$state.params.category}`;
                    }
                ]
            }
        })
        .state('shop.search.zero-result', {
            url: '/zeroresult',
            data: {
                analytics: `bws:web:zeroresult`
            },
            onEnter: [
                'PerformanceMeasurerService', function (performance) {
                    performance.startMeasure('search.zero result');
                }
            ],
            views: {
                'left-panel@': {
                    controller: [
                        'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                            $scope.breakpointsService = breakpointsService;
                        }
                    ],
                    template: '<wow-search-navigation disable-navigation-links="true" get-counts="true" ng-if="!breakpointsService.isSmallFormat()"></wow-search-navigation><wow-search-zero-results ng-if="breakpointsService.isSmallFormat()"></wow-search-zero-results>'
                },
                'center-panel@': {
                    template: '<wow-search-zero-results></wow-search-zero-results>'
                }
            }
        })
        .state('shop.search.external-result', {
            url: '/external-result',
            data: {
                analytics: `bws:web:external-result`
            },
            views: {
                'left-panel@': {
                    controller: [
                        'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                            $scope.breakpointsService = breakpointsService;
                        }
                    ],
                    template: '<wow-search-navigation disable-navigation-links="true" get-counts="false" ng-if="!breakpointsService.isSmallFormat()"></wow-search-navigation><wow-search-external-result ng-if="breakpointsService.isSmallFormat()"></wow-search-external-result>'
                },
                'center-panel@': {
                    template: '<wow-search-external-result></wow-search-external-result>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/search.js
 **/